import { render } from "./ApplicationDangerZone.vue?vue&type=template&id=6b07781f&scoped=true"
import script from "./ApplicationDangerZone.vue?vue&type=script&lang=js"
export * from "./ApplicationDangerZone.vue?vue&type=script&lang=js"

import "./ApplicationDangerZone.vue?vue&type=style&index=0&id=6b07781f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b07781f"]])

export default __exports__